import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import Header from "../components/Header";
import Filhos from "../components/Filhos";

import Bg from "../img/services/2.jpg"

import BtWhatsapp from "../components/ButtonWhatsapp3";

const FilhosBreadcrumb = () => {
  return (
    <>
      <Header />
      <main>
        <Breadcrumb
          menu="Serviços"
          name="Investigação de filhos" 
          bg={Bg}
        />
        <Filhos />
        <Footer />
      </main>
      <BtWhatsapp />
      <Scrolltop />
    </>
  );
};

export default FilhosBreadcrumb;
